import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Container from 'components/v2/container';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import { ACCESSORIAL_PDFS } from 'constants/pdf';
import AlertNotificator from 'components/site/notifications/AlertNotificator';
import CreditCardForm from 'components/modules/user/shipper/billing/CreditCardForm';
import BillingAddressForm from 'components/modules/user/billing-address-form';
import SessionStore from 'stores/SessionStore';
import ToastStore from 'stores/ToastStore';
import Sidebar from '../../../shipper/Sidebar';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
class Details extends Component {
    constructor() {
        super(...arguments);
        this.onSaveBillingAddress = (data) => {
            ToastStore.removeLatestNotification();
            const shipperId = SessionStore.getUser()._id;
            const shipper = {
                _id: shipperId,
                billing_address: data,
            };
            CustomersActionCreators.validateAndUpdateBillingAddress(shipper);
        };
    }
    render() {
        const shipperDetails = SessionStore.getUser();
        const { t } = this.props;
        return (React.createElement(Container, null,
            React.createElement("div", { className: "lg:grid lg:grid-cols-12 lg:gap-6 mt-10" },
                React.createElement("div", { className: "lg:col-span-3" },
                    React.createElement(Sidebar, { activePage: "billing" }),
                    React.createElement("div", { className: "billing-accessorial-pdf" },
                        React.createElement("a", { href: ACCESSORIAL_PDFS.shipper, target: "_blank", rel: "noopener noreferrer", className: "mt-4 text-sm" },
                            React.createElement("span", null, t('VIEW_ACCESSORIAL_DEF_CHARGES'))))),
                React.createElement("div", { className: "lg:col-span-6" },
                    React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                        React.createElement(CreditCardForm, { className: "mb-6" })),
                    React.createElement(AlertNotificator, null),
                    React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                        React.createElement(BillingAddressForm, { className: "mb-6", details: shipperDetails.billing_address, onSave: this.onSaveBillingAddress }))))));
    }
}
export default withTranslation()(Details);
